module.exports = __webpack_public_path__ + "static/img/xcx.e34076af.png";